import { SectionHelper } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectRequestSuccessManagerSent } from '../../../pages/RequestSuccessManagerForm/redux/selectors';
import { requestSuccessManagerSlice } from '../../../pages/RequestSuccessManagerForm/redux/slice';
import { NotificationWrapper } from '../NotificationWrapper';

export const RequestSuccessManagerNotification: FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const requestSuccessManagerSent = useSelector(selectRequestSuccessManagerSent);
  const closeNotification = useCallback(() => dispatch(requestSuccessManagerSlice.actions.reset()), []);

  useEffect(() => {
    if (requestSuccessManagerSent) {
      setTimeout(() => {
        closeNotification();
      }, 3000);
    }
  }, [requestSuccessManagerSent]);

  return (
    <NotificationWrapper>
      <SectionHelper
        dataHook="request-success-manager-notification"
        appearance="success"
        title={t('request_success_manager_sent_success_title')}
        size="small"
        showCloseButton
        onClose={closeNotification}
      >
        {t('request_success_manager_sent_success_message')}
      </SectionHelper>
    </NotificationWrapper>
  );
};
